import React from 'react';
import moment from 'moment';
import TimePicker from 'rc-time-picker';
import { Element } from 'components/forms/form-elements';

const timePickerProps = { format: 'h:mm a', use12Hours: true, inputReadOnly: true, showSecond: false, minuteStep: 10 };
const timePickerStartProps = { ...timePickerProps, defaultOpenValue: moment().hour(7).minute(0) };
const timePickerEndProps = { ...timePickerProps, defaultOpenValue: moment().hour(17).minute(0) };

export default function BusinessHoursPicker({ input, meta, label, ...props }) {
  const start = input.value.start ? moment(input.value.start, 'HH:mm') : null;
  const end = input.value.end ? moment(input.value.end, 'HH:mm') : null;
  const open = !!input.value.open;
  
  const onStartChange = value => {
    input.onChange({ ...input.value, start: value ? value.format('HH:mm') : value });
  };

  const onEndChange = value => {
    input.onChange({ ...input.value, end: value ? value.format('HH:mm') : value });
  };

  const onOpenChange = event => {
    const value = event.target.checked;

    input.onChange({
      open: value,
      start: value ? input.value.start : null,
      end: value ? input.value.end : null
    });
  };

  return (
    <Element {...props} {...meta}>
      <div className="form-flex-row mb-2">
        <div className="text-right d-inline-flex align-items-center justify-content-end">
          <span className="mr-2">{label}</span>
          <input type="checkbox" onChange={onOpenChange} checked={open} />
        </div>
        <TimePicker {...timePickerStartProps} value={start} onChange={onStartChange} disabled={!open} />
        <TimePicker {...timePickerEndProps} value={end} onChange={onEndChange} disabled={!open} />
      </div>
    </Element>
  );
}
